import { render, staticRenderFns } from "./fccTratamentoCandidatosBusca.vue?vue&type=template&id=e43333f4"
import script from "./fccTratamentoCandidatosBusca.vue?vue&type=script&lang=js"
export * from "./fccTratamentoCandidatosBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports